import {useEffect, useRef} from "react";

interface IToggleStyledProps {
    onClick: Function,
    width?: number,
    height?: number,
    handleColor?: string,
    text?: string,
    textClasses?: string,
    textStyles?: any,
    padding?: number,
    isPositionRight?: boolean,
    isToogle?: boolean,
    adaText?: string,
}

/**
 * Toggle widget.
 */
export const ToggleStyled = (props: IToggleStyledProps) => {
    const {
        isToogle,
        onClick,
        width = 70,
        height = 26,
        handleColor = '#686868',
        text,
        textClasses,
        textStyles,
        padding = 2,
        adaText,
    } = props;

    const btnToogle = !!isToogle;
    const handleSize = height - padding - padding * 2;
    const textRef = useRef<HTMLSpanElement>(null);

    useEffect(() => {
        // Можно оставить как есть, но обязательно добавить зависимости!
        // иначе лишние ререндеры!
    }, [width, padding, handleSize, text, textStyles]);

    let checkedPositionClass = isToogle ? 'toggle-switch__checked' : '';
    if (props.isPositionRight) {
        checkedPositionClass = isToogle ? '' : 'toggle-switch__checked';
    }

    return (
        <label
            className={`toggle-styled toggle-switch ${checkedPositionClass} border rounded-3xl bg-white block cursor-pointer flex relative`}
            style={{
                width: `${width}px`,
                height: `${height}px`,
                padding: `${padding}px`,
            }}
        >
            <input
                type="checkbox"
                checked={btnToogle}
                onChange={() => onClick(!btnToogle)}
                aria-label={adaText ?? "Toggle"}
                style={{
                    opacity: 0,
                    width: 0,
                    height: 0,
                    position: 'absolute',
                }}
                tabIndex={-1}
            />
            <span
                className="toggle-switch__handle block"
                style={{
                    width: `${handleSize}px`,
                    height: `${handleSize}px`,
                    borderRadius: '100%',
                    backgroundColor: handleColor,
                }}
            />
            {text &&
                <span
                    ref={textRef}
                    className={`toggle-switch__text relative flex items-center flex-1 text-center justify-center text-xs font-normal text-center text-gray-500 ${textClasses}`}
                    style={textStyles}
                >{text}</span>
            }
            <span className="sr-only">Toggle</span>
        </label>
    );
};
